<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <div>
    <vs-collapse class="p-0 m-0 bg-white" type="margin">
      <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down">
        <div slot="header">
          <feather-icon
            icon="FilterIcon"
            svgClasses="text-primary"
          ></feather-icon
          >فیلترها
        </div>
        <form
          @keyup.enter="
            pageNo = 1;
            getData();
          "
        >
          <div class="vx-row mb-2">
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>درگاه:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <select-account
                    title=""
                    :userId="uid"
                    v-model="accountId"
                    :showConsumerAccount="false"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>از تاریخ:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <date-picker
                    inputClass="py-1 px-5  w-full"
                    v-model="filters.dateFrom"
                  ></date-picker>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>تا تاریخ:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <date-picker
                    inputClass="py-1 px-5 w-full"
                    v-model="filters.dateTo"
                  ></date-picker>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>از مبلغ:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <vs-input
                    inputmode="numeric"
                    v-model="filters.minAmount"
                    v-focus
                    class="w-full"
                  />
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>تا مبلغ:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <vs-input
                    inputmode="numeric"
                    v-model="filters.maxAmount"
                    class="w-full"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col">
              <vs-button
                @click="clear"
                class="mx-3"
                color="primary"
                type="border"
                >پاک کردن</vs-button
              >
            </div>
            <div class="vx-col">
              <vs-button
                @click="
                  pageNo = 1;
                  getData();
                "
                class="mx-3"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-search"
                >جستجو</vs-button
              >
            </div>
          </div>
        </form>
      </vs-collapse-item>
    </vs-collapse>

    <vx-card class="mb-2" :title="title">
      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-button
            class="mr-3 mb-2"
            @click="$router.go(-1)"
            type="flat"
            icon-pack="feather"
            icon="icon-chevron-right"
            >بازگشت</vs-button
          >
        </div>
      </div>
      <vs-table id="tbl2" ref="tbl2" :data="items0" class="table-dark-inverted">
        <template slot="header">
          <div class="vx-row mb-2 w-full">
            <div class="vx-col sm:w-2/3 flex-inline">
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <div
                        class="
                          p-3
                          border border-solid
                          d-theme-border-grey-light
                          rounded-full
                          d-theme-dark-bg
                          cursor-pointer
                          flex
                          items-center
                          justify-between
                          font-medium
                        "
                      >
                        <span class="mr-2">
                          {{ (pageNo - 1) * pageSize + 1 }}
                          -
                          {{
                            pageNo * pageSize > totalCount
                              ? totalCount
                              : pageNo * pageSize
                          }}
                          از {{ totalCount }}
                        </span>
                        <feather-icon
                          icon="ChevronDownIcon"
                          svgClasses="h-4 w-4"
                        />
                      </div>
                      <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="SetPageSize(5)">
                          <span>5</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(10)">
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(20)">
                          <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(50)">
                          <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(100)">
                          <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(150)">
                          <span>150</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-1/3 flex-inline">
              <span style="float: left">
                کاردکرد روزانه:
                {{ creditBalance }}
              </span>
            </div>
          </div>
        </template>
        <template slot="thead">
          <vs-th></vs-th>
          <vs-th>تاریخ</vs-th>
          <vs-th class="w-2">مبلغ</vs-th>
          <vs-th class="w-12">کارمزد</vs-th>
          <vs-th class="w-2">واریزی</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <span>{{ indextr + 1 }}</span>
            </vs-td>
            <vs-td>
              <span>{{
                !tr.settlementDate
                  ? "&nbsp;"
                  : $moment(tr.settlementDate).format(
                      "HH:mm:ss - jYYYY/jMM/jDD"
                    )
              }}</span>
            </vs-td>
            <vs-td class="text-success amount-nav">
              <span>{{
                parseInt(tr.amount + tr.merchantCommission).toLocaleString()
              }}</span>
            </vs-td>
            <vs-td class="text-danger amount-nav">
              <span>{{
                parseInt(tr.merchantCommission).toLocaleString()
              }}</span>
            </vs-td>
            <vs-td class="text-success amount-nav">
              <span>{{ parseInt(tr.amount).toLocaleString() }}</span>
            </vs-td>
            <vs-td>
              <a
                v-if="tr.state == 4"
                @click="showError(tr.errorMessage, tr.settlementDate)"
                >خطا</a
              >
              <a
                @click="showTransaction(tr.settlementId, tr.settlementDate)"
                v-else
                >تراکنشها</a
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <paginate
        v-model="pageNo"
        :page-count="pagesCount"
        :click-handler="getData"
      />
      <transaction-details ref="TransactionDetails1"></transaction-details>

      <vs-popup
        popup-class="w-9/12"
        :title="errorMessage.date"
        :active.sync="popupActive"
      >
        <span dir="ltr">
          <vue-json-pretty :path="'res'" :data="errorMessage.msg">
          </vue-json-pretty>
        </span>
      </vs-popup>
    </vx-card>
  </div>
</template>
<style  lang="scss">
.amount-nav {
  text-align: right;
  div {
    display: block;
    position: relative;
    span {
      top: 0px !important;
      position: absolute !important;
      left: 0;
      &:first-child {
        top: -2px !important;
      }
    }
    & + span {
      margin-left: 7px;
    }
  }
}
</style>
<script>
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import vSelect from "vue-select";
import {} from "@/enums.js";
import TransactionDetails from "../transaction/TransactionDetails.vue";
import Vue from "vue";
export default {
  components: {
    "v-select": vSelect,
    TransactionDetails,
    VueJsonPretty,
  },
  data() {
    return {
      accountId: null,
      items0: [],
      creditBalance: 0,
      totalCount: 1,
      pageSize: 10,
      pagesCount: 1,
      pageNo: 1,
      popupActive: false,
      errorMessage: {
        msg: "",
        date: null,
      },
      filters: {
        maxAmount: "",
        minAmount: "",
        dateTo: "",
        dateFrom: "",
      },
    };
  },
  computed: {
    uid() {
      return this.$route.query.userId || "";
    },
    title() {
      return this.$route.query.shopName
        ? `تسویه‌حساب‌های پذیرنده "${this.$route.query.shopName}"`
        : "";
    },
  },
  methods: {
    initFilters() {
      if (Object.keys(this.$route.query).length != 0) {
        this.pageSize = this.$route.query.ps || this.pageSize;
        this.pageNo = parseInt(this.$route.query.pno) || this.pageNo;
        this.filters.minAmount = this.$route.query.na || this.filters.minAmount;
        this.filters.maxAmount = this.$route.query.xa || this.filters.maxAmount;
        this.filters.dateFrom = this.$route.query.df || this.filters.dateFrom;
        this.filters.dateTo = this.$route.query.dt || this.filters.dateTo;
        this.accountId = this.$route.query.aid || this.accountId;
      }
    },
    getData() {
      const query = {
        ps: this.pageSize,
        pno: this.pageNo,
      };
      if (this.filters.maxAmount) query.xa = this.filters.maxAmount;
      if (this.filters.minAmount) query.na = this.filters.minAmount;
      if (this.accountId) query.aid = this.accountId;
      if (this.$route.query.userId) query.userId = this.$route.query.userId;
      if (this.$route.query.shopName)
        query.shopName = this.$route.query.shopName;

      let loading = this.$vs.loading();
      let payload = {
        params: {
          MaxAmount: this.filters.maxAmount,
          MinAmount: this.filters.minAmount,
          MaxResultCount: this.pageSize,
          SkipCount: this.pageSize * (this.pageNo - 1),
        },
      };
      if (this.accountId) payload.params.accountId = this.accountId;
      if (this.filters.dateFrom != "") {
        payload.params.dateTimeFrom = this.$moment(
          this.filters.dateFrom,
          "jYYYY/jMM/jDD"
        ).format();
        query.df = this.filters.dateFrom;
      }
      if (this.filters.dateTo != "") {
        payload.params.dateTimeTo = this.$moment(
          this.filters.dateTo,
          "jYYYY/jMM/jDD"
        ).format("YYYY-MM-DDT23:59:59.9999999Z");
        query.dt = this.filters.dateTo;
      }
      this.$router.replace({
        query: query,
      });

      this.$http
        .get("/api/services/app/Settlements/GetSettlements", payload)
        .then((response) => {
          this.items0 = response.data.result.items;
          this.creditBalance = response.data.result.creditBalance;
          this.totalCount = response.data.result.totalCount;
          this.pagesCount = Math.ceil(this.totalCount / this.pageSize);
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    clear() {
      this.filters.filter = "";
      this.filters.dateFrom = "";
      this.filters.dateTo = "";
      this.filters.minAmount = "";
      this.filters.maxAmount = "";
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData();
    },
    showError(errorMessage, settlementDate) {
      this.popupActive = true;
      this.errorMessage.date =
        "تسویه " +
        this.$moment(settlementDate).format("HH:mm:ss - jYYYY/jMM/jDD");
      this.errorMessage.msg = JSON.parse(errorMessage);
    },
    showTransaction(settlementId, settlementDate) {
      let query = {
        settlementDate: settlementDate,
        sett: settlementId,
      };
      if (this.$route.query.shopName)
        query.shopName = this.$route.query.shopName;
      this.$router.push({
        name: "SettlementTransactions",
        query: query,
      });
    },
  },
  mounted() {
    this.initFilters();
    this.getData();
    // this.$refs.tbl2.$on('selected', selected => {
    //         console.log(selected);
    //       });
  },
};
</script>
